import React from 'react'

interface Props {
  update: React.Dispatch<React.SetStateAction<number>>
  amt: number
}

const QuantityAdjuster: React.FunctionComponent<Props> = ({ update, amt }): JSX.Element => {
  
  const increaseQuanity = () => {
    update(amt + 1)
  }

  const decreaseQuantity = () => {
    update(amt - 1)
  }

  return (
    <div className="quantity-selector-wrapper" data-quantity-selector>
      <button role="button"
        type="button"
        data-quantity-dec
        disabled={amt <= 0}
        onClick={decreaseQuantity}
        className="btn-quantity-selector btn-dec"
        aria-label="decrease quantity"></button>
      <input type="number"
        className="text-input input-quantity"
        value={amt}
        name="updates[]"
        data-quantity-input
        onChange={(e) => update(parseInt(e.target.value)) }
        aria-label="{{ 'cart.general.item_quantity' | t }}"/>
      <button role="button"
        type="button"
        data-quantity-inc
        onClick={increaseQuanity}
        className="btn-quantity-selector btn-inc"
        aria-label="increase quantity"></button>
    </div>
  )
}

export default QuantityAdjuster